import DropdownFilter from "@/components/dropdown_filter";

import Paginator from '@/components/paginator';
import AgencyTile from "@/components/agency_tile";
import Loader from "@/components/loading_animation.js";
export default function AgencyLocatorTileListView({agencyNameSearch, stateProvinceOptions, searchState, searchAgencies, 
                                                   isLoading, searchInput, agents, totalCount, countries }) {

return (<section className="lexcms-agent-locator-page-container">
              <section className="lexcms-agent-locator-search-bar-container">
                  <input
                    ref={searchInput}
                    type="search"
                    onKeyUp={(event) => {    agencyNameSearch(event.target.value, searchState)  } }
                    defaultValue={searchState.search['q[name_cont]'] || ''}
                    placeholder="Search for Agencies"
                    className="lexcms-agent-locator-search"
                  />
                  <DropdownFilter searchKey={'q[state_eq]'} 
                    className='lexcms-agent-locator-state-province-filter'
                    searchState={searchState}
                    options={stateProvinceOptions} 
                    label={'Filter by State or Province'} />
                    {countries.length > 1  &&
                    <DropdownFilter searchKey={'q[country_eq]'} 
                      className='lexcms-agent-locator-state-province-filter'
                      searchState={searchState}
                      options={ countries.map(c => ({ label: c[0], value: c[1] }))
} 
                      label={'Filter by Country'} />
                    }

                  <button className="lexcms-regular-button lexcms-agent-locator-clear-search-button"
                   onClick={ ( ) => {searchAgencies({}); 
                      searchState.clearAll(); 
                      if ( searchInput.current) {
                        searchInput.current.value = "";
                      } }} >
                    Clear Results
                  </button>
              </section>
              <section className="lexcms-agent-locator-tile-grid-container">
                {isLoading && <Loader />}
                {agents.length <= 0 &&
                  <div className ="lexcms-no-results-found-container">
                    <div className="lexcms-no-results-found-image">
                    </div>
                      <h2 className="lexcms-no-results-found-text">No Results Found. Try Refining Your Search
                      </h2>
                  </div>
                } 
                {agents && agents.map((agency, i) => {
                  return (<AgencyTile agency={agency} key={i}  /> )
                })
                }
              </section>
              {totalCount > 100 &&
                <Paginator itemsPerPage={100} pageRangeDisplayed={5} totalCount={totalCount} 
                search={searchState}   />
              }
            </section>)
}
